import { Button, Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from '../../app.module.css';
import { Link } from 'react-router-dom';

export const ErrorModal = ({
  opened,
  onClose,
  title,
  message,
}: {
  opened: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}) => {
  const { t } = useTranslation('common');
  return (
    <Modal
      classNames={{ content: classes.modalContentWhite }}
      opened={opened}
      onClose={onClose}
      title={title || t('common:error_title_default')}
    >
      <Stack>
        <Text>
          {message || t('common:error_message_default')}
          <Link to={'/'}>{t('support_team')}.</Link>
        </Text>
        <Button>
          <Button fullWidth onClick={onClose}>
            {t('common:understood')}
          </Button>
        </Button>
      </Stack>
    </Modal>
  );
};
